// This map will need to be updated for each feature that is implemented in the management portal
// This allows for a centralized naming area and allows for icon distribution by name
export const featureNames = {
  GPU: "gpu",
};
